import { render, staticRenderFns } from "./MaterialPerLocationModal.vue?vue&type=template&id=794f0526&"
import script from "./MaterialPerLocationModal.vue?vue&type=script&lang=js&"
export * from "./MaterialPerLocationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports